export const FormTypes = {
  HUBSPOT: 'HUBSPOT',
  VIDEO_FORM: 'VIDEO_FORM'
};